import React from 'react'
import { Close } from '../../../assets/icons'
import { TagContainer, RemoveButton } from './styled'

const Tag = ({ label, onRemove, ...props }) => (
	<TagContainer {...props}>
		{label}
		<RemoveButton type="button" onClick={onRemove} aria-label={`Remover ${label}`}>
			<Close width={14} height={14} color="#0052CC" />
		</RemoveButton>
	</TagContainer>
)

export default Tag
